const ACTION_TYPES: Dict<string> = {
  SET_FORM_CONFIG: 'SET_FORM_CONFIG',
  SET_GLOBAL_CONFIG: 'SET_GLOBAL_CONFIG',
  SET_APP_CONFIG_LOAD_STATUS: 'SET_APP_CONFIG_LOAD_STATUS',
  SET_LANGUAGE: 'SET_LANGUAGE',
  SET_TERMS_CONFIG: 'SET_TERMS_CONFIG',
  SET_FORM_NEXT_STEP: 'SET_FORM_NEXT_STEP',
  SET_FORM_PREV_STEP: 'SET_FORM_PREV_STEP',
  SET_TERMS_NEXT_STEP: 'SET_TERMS_NEXT_STEP',
  SET_TERMS_ACCEPTANCE: 'SET_TERMS_ACCEPTANCE',
  UNBLOCK_REGISTER_FORM: 'UNBLOCK_REGISTER_FORM',
  SET_REGISTER_DATA: 'SET_REGISTER_DATA',
  SET_TELEPHONE_NUMBER_FORMAT: 'SET_TELEPHONE_NUMBER_FORMAT',
  SET_FORM_STEP: 'SET_FORM_STEP',
  SET_BACK_FROM_SUMMARY_STEP: 'SET_BACK_FROM_SUMMARY_STEP',
  SET_ACCEPTED_STEPS: 'SET_ACCEPTED_STEPS',
  SET_APPLICATION_SENT: 'SET_APPLICATION_SENT',
  SET_FORM_INITIAL_VALUES: 'SET_FORM_INITIAL_VALUES',
  SET_DISABLE_SUBMIT: 'SET_DISABLE_SUBMIT',
  SET_MESSAGE_FROM_BACKEND: 'SET_MESSAGE_FROM_BACKEND',
  SET_LOADER: 'SET_LOADER',
  SET_VALIDATION_ERRORS: 'SET_VALIDATION_ERRORS',
  SET_SERVER_ERROR: 'SET_SERVER_ERROR',
  SET_RESULT_CODE: 'SET_RESULT_CODE',
  SET_URL_PARAMS: 'SET_URL_PARAMS',
  RESET_REGISTER_DATA: 'RESET_REGISTER_DATA',
  RESET_ACCEPTED_STEPS: 'RESET_ACCEPTED_STEPS',
  SET_ERROR_PAGE: 'SET_ERROR_PAGE',
  SET_FORM_SESSION: 'SET_FORM_SESSION',
  RESET_FORM_SESSION: 'RESET_FORM_SESSION',
  SET_PREVIEW_FORM: 'SET_PREVIEW_FORM',
  SET_ORGANISATION_FORM_QUESTION: 'SET_ORGANISATION_FORM_QUESTION',
  SET_FORM_ELEMENTS: 'SET_FORM_ELEMENTS',
  SET_APP_ERROR: 'SET_APP_ERROR',
  SET_CUSTOM_FIELDS: 'SET_CUSTOM_FIELDS',
  SET_SELECTED_COUNTRY: 'SET_SELECTED_COUNTRY',
  SET_FORM_SESSION_EVENTS_LIST: 'SET_FORM_SESSION_EVENTS_LIST',
  SET_FORM_SESSION_DROPDOWN_LIST: 'SET_FORM_SESSION_DROPDOWN_LIST',
  SET_FORM_SESSION_TOKEN: 'SET_FORM_SESSION_TOKEN',

  SET_GLOBAL_DEFAULT_LANGUAGE: 'SET_GLOBAL_DEFAULT_LANGUAGE',
  SET_GLOBAL_LANGUAGES: 'SET_GLOBAL_LANGUAGES',
  SET_ACCOUNT_DATA: 'SET_ACCOUNT_DATA',
  SET_USER_ALREADY_AVAILABLE_FORM_PATH: 'SET_USER_ALREADY_AVAILABLE_FORM_PATH',
  LOGOUT: 'LOGOUT',
  SET_ACCOUNT_REGISTER_URL: 'SET_ACCOUNT_REGISTER_URL',
  SET_PROJECT_IMAGE_RULES: 'SET_PROJECT_IMAGE_RULES',
};

export default ACTION_TYPES;
